import { render, staticRenderFns } from "./AdminBaseCompetences.vue?vue&type=template&id=053430c9"
import script from "./AdminBaseCompetences.vue?vue&type=script&lang=js"
export * from "./AdminBaseCompetences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports